// extracted by mini-css-extract-plugin
module.exports = {"buttons":"buttons--3jtyU6sDvw"};